import React from 'react'

// icons
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// router
import { withRouter } from 'react-router-dom'
import useDelete from './hooks/useDelete'

const ItemFamiliaEliminada = ({ familia, setIsLoad }) => {
    const { recoverFamiliaSubmit } = useDelete(setIsLoad)
    return (
        <tr>
            <th scope="row">{familia.id}</th>
            <td>{familia.nombre}</td>
            <td>{familia.ganancia}</td>
            <td>
                <button
                    className="btn text-warning"
                    onClick={() => {
                        recoverFamiliaSubmit(familia)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} /> Recuperar
                </button>
            </td>
        </tr>
    )
}

export default withRouter(ItemFamiliaEliminada)
